import { getConfigFor } from '@/globals/config/helpers/getConfigFor';
import { translateInline } from '@/globals/translate/translateInline';

export const amendmentFilterQueryKeys = getConfigFor.project<{
	subject: string;
	sector: string;
}>({
	op: {
		subject: 'onderwerp',
		sector: 'branche',
	},
	bgov: {
		subject: 'subject',
		sector: 'sector',
	},
});

export const amendmentFilterGroupKeys = Object.values(amendmentFilterQueryKeys);

export type AmendmentFilterOption = {
	key: string;
	name: string;
};

export type AmendmentFilters = {
	subjects: Array<AmendmentFilterOption>;
	sectors: Array<AmendmentFilterOption>;
};

type AmendmentFilterGroupDefinition = {
	key: keyof AmendmentFilters;
	queryKeyRef: keyof typeof amendmentFilterQueryKeys;
	label: string;
	selectAllText: string;
};

export const filterGroups: Array<AmendmentFilterGroupDefinition> = [
	{
		key: 'subjects',
		queryKeyRef: 'subject',
		label: translateInline({ en: 'Topic', nl: 'Onderwerp' }),
		selectAllText: translateInline({
			en: 'All topics',
			nl: 'Alle onderwerpen',
		}),
	},
	{
		key: 'sectors',
		queryKeyRef: 'sector',
		label: translateInline({ en: 'Sector', nl: 'Branche' }),
		selectAllText: translateInline({ en: 'All sectors', nl: 'Alle branches' }),
	},
];
